import { render, staticRenderFns } from "./ChannelSelector.vue?vue&type=template&id=460168e2&"
import script from "./ChannelSelector.vue?vue&type=script&lang=ts&"
export * from "./ChannelSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports